import axios from '@/utils/request'
// 获取用户信息
export function getUserInfo() {
    return axios({
        url: '/user/profile',
        method: 'get',
    })
}
//登录
export function login(data) {
    return axios({
        url: '/user/stu_login',
        method: 'post',
        data
    })
}
//退出
export function logout(data) {
    return axios({
        url: '/user/logout',
        method: 'post',
        data
    })
}
//获取验证码
export function captcha() {
    return axios({
        url: '/misc/captcha/api',
        method: 'get',
    })
}
//修改基本信息
export function editBase(data) {
    return axios({
        url: '/user/info/basic',
        method: 'post',
        data
    })
}
//修改联系方式
export function editContact(data) {
    return axios({
        url: '/user/info/contact',
        method: 'post',
        data
    })
}
//修改密码
export function passwd(data) {
    return axios({
        url: '/user/passwd',
        method: 'post',
        data
    })
}
//修改用户头像
export const api_avatar = process.env.VUE_APP_PREFIX + '/my/photo'